// slices/userSetupSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
};

const userSetupSlice = createSlice({
  name: 'userSetup',
  initialState,
  reducers: {
    addUser: (state) => {
      state.users.push({
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        userAs: '',
        category: '',
        status: 'Edit', // Status can be 'Edit' or 'Saved'
      });
    },
    removeUser: (state, action) => {
      state.users.splice(action.payload, 1);
    },
    updateUser: (state, action) => {
      const { index, user } = action.payload;
      state.users[index] = {
        ...state.users[index],
        ...user, // Merge the existing user data with the updated fields
      };
    },
    toggleUserStatus: (state, action) => {
      const user = state.users[action.payload];
      user.status = user.status === 'Edit' ? 'Saved' : 'Edit';
    },
  },
});

export const { addUser, removeUser, updateUser, toggleUserStatus } = userSetupSlice.actions;
export default userSetupSlice.reducer;
